import {Locale} from '@raison/types';

export const stablecoins = ['USDC', 'USDT', 'DAI'];
export const maxTriesCount = 5;
export const maxAwaitTime = 2000;
export const locale = 'en-GB' as Locale;
export const timeZone = 'UTC';
export const MINIMAL_WITHDRAW_AMOUNT = 10;
export const NON_UTC_COINS = ['USDC', 'USDT', 'RSN', 'UAIR'];

// messages
export const SERVICE_UNAVAILABLE_MESSAGE = 'Service is temporary unavailable';
export const CONTACT_US_MESSAGE = 'contact us';
export const CONTACT_SUPPORT_MESSAGE = 'contact support';

export const MAX_SUPPORT_MESSAGE_LENGTH = 8912;

export const TOKEN_PURCHASE_CURRENCY = 'USD'; // 'USD' | 'EUR'
export const PAYMENT_RESTRICTED_ROLE = 'ROLE_BLOCKED_SERVICE_PROVIDER';
export const IOS_LINK_KEY = '?ios=1&key=4sf4tNk97JnZlpZ6&v=2';

export const MAX_DECIMALS_IN_WALLET_VIEW = 5;
export const PRIMARY_CURRENCY_DECIMALS = 2;

/**
 * This values should be used when:
 * - formatting amounts of cryptocurrency (including tokens)
 * - setting limit on input length (such as maxDecimals)
 *
 * It should not be used in computations or before sending amounts to server.
 *
 * Remainders can be rounded up either way as long as user is informed about
 * final amounts.
 */
export const MAX_DECIMALS_IN_CRYPTO = 8;

export const GROWTH_VIEW_ENABLED = false;
